<div id="composant" class="col-xs-12 col-md-6">

    <div id="container"></div>
</div>
